import loadable from '@loadable/component';

export const UserDashboardCreateEventPageLoadable = loadable(
  () => import('./UserDashboardCreateEventPage'),
  {
    resolveComponent: (module) => module.UserDashboardCreateEventPage,
  },
);
